import { Button, Menu, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";

const SortMenu = [
  { label: "Most Recent", key: "created_at", id: 1 },
  { label: "Loan Amount Asc", key: "loanamount", id: 2 },
  { label: "Loan Amount Dsc", key: "loanamount", id: 3 },
];

const SortBy = (props) => {
  const [sortByVal, setSortByVal] = useState("Most Recent");
  const [sortByEl, setsortByEl] = useState(null);
  const dropdownopen = Boolean(sortByEl);

  useEffect(() => {
    if (props?.value !== undefined && props.value !== "") {
      const temp = SortMenu.filter((it) => it?.id === props?.value);
      setSortByVal(temp[0].label);
    }
  }, [props?.value]);
  const handleDropdownClick = (event) => {
    setsortByEl(event.currentTarget);
  };
  const handleDropdownChange = (ans, value) => {
    props.handleSortBy(ans, value);
    setSortByVal(ans);
    setsortByEl(null);
  };
  return (
    <div
      className={`select_opt relative bottom-[2px] pl-[20px] right-[20px] cursor-pointer shrink-0`}
    >
      <img
        src="/images/select_icon2.svg"
        alt="arrow"
        className="absolute top-[11px] left-[22px]"
      />
      <img
        src="/images/select_icon1.svg"
        alt="arrow"
        className="absolute top-[15px] right-[2px]"
      />
      <Button
        id="sortby-button"
        aria-controls={dropdownopen ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={dropdownopen ? "true" : undefined}
        onClick={handleDropdownClick}
      >
        {sortByVal}
      </Button>
      <Menu
        id="sortby-menu"
        anchorEl={sortByEl}
        open={dropdownopen}
        onClose={() => setsortByEl(null)}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {SortMenu.map((item, idx) => {
          return (
            <MenuItem
              key={item?.key}
              onClick={() => handleDropdownChange(item?.label, item?.id)}
            >
              {item.label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default SortBy;
